import { render, staticRenderFns } from "./invoiceHotel.vue?vue&type=template&id=25c40823&scoped=true&"
import script from "./invoiceHotel.vue?vue&type=script&lang=js&"
export * from "./invoiceHotel.vue?vue&type=script&lang=js&"
import style0 from "./invoiceHotel.vue?vue&type=style&index=0&id=25c40823&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c40823",
  null
  
)

export default component.exports